import styled from 'styled-components/macro';

const InnerCircle = styled.div`
  align-items: center;
  background: #dfdfdf;
  border-radius: 50%;
  box-shadow: inset 0px 10px 5px 0px rgba(168, 168, 168, 1);
  display: flex;
  height: 80%;
  justify-content: center;
  width: 80%;
`;

export default InnerCircle;
